export const contactList = [
  {
    id: "1",
    name: "მარიამ გრიგოლაშვილი",
    status: true,
    isGroup: false,
    newMessages: 4,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "TEXT", //  TEXT, PHOTO, FILE
  },
  {
    id: "2",
    name: "მარიამ გრიგოლაშვილი",
    status: false,
    isGroup: false,
    newMessages: 0,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "TEXT", //  TEXT, PHOTO, FILE
  },
  {
    id: "3",
    name: "მარიამ გრიგოლაშვილი",
    status: true,
    isGroup: false,
    newMessages: 20,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "TEXT", //  TEXT, PHOTO, FILE
  },
  {
    id: "3",
    name: "მარიამ გრიგოლაშვილი",
    status: false,
    isGroup: false,
    newMessages: 0,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "TEXT", //  TEXT, PHOTO, FILE
  },
  {
    id: "3",
    name: "უჯგუფესი ჯგუფი",
    status: true,
    isGroup: true,
    newMessages: 1,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "PHOTO", //  TEXT, PHOTO, FILE
  },
  {
    id: "1",
    name: "მარიამ გრიგოლაშვილი",
    status: true,
    isGroup: false,
    newMessages: 4,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "TEXT", //  TEXT, PHOTO, FILE
  },
  {
    id: "2",
    name: "მარიამ გრიგოლაშვილი",
    status: false,
    isGroup: false,
    newMessages: 0,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "TEXT", //  TEXT, PHOTO, FILE
  },
  {
    id: "3",
    name: "მარიამ გრიგოლაშვილი",
    status: true,
    isGroup: false,
    newMessages: 20,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "TEXT", //  TEXT, PHOTO, FILE
  },
  {
    id: "3",
    name: "მარიამ გრიგოლაშვილი",
    status: false,
    isGroup: false,
    newMessages: 0,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "TEXT", //  TEXT, PHOTO, FILE
  },
  {
    id: "3",
    name: "უჯგუფესი ჯგუფი",
    status: true,
    isGroup: true,
    newMessages: 1,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "PHOTO", //  TEXT, PHOTO, FILE
  },
  {
    id: "1",
    name: "მარიამ გრიგოლაშვილი",
    status: true,
    isGroup: false,
    newMessages: 4,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "TEXT", //  TEXT, PHOTO, FILE
  },
  {
    id: "2",
    name: "მარიამ გრიგოლაშვილი",
    status: false,
    isGroup: false,
    newMessages: 0,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "TEXT", //  TEXT, PHOTO, FILE
  },
  {
    id: "3",
    name: "მარიამ გრიგოლაშვილი",
    status: true,
    isGroup: false,
    newMessages: 20,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "TEXT", //  TEXT, PHOTO, FILE
  },
  {
    id: "3",
    name: "მარიამ გრიგოლაშვილი",
    status: false,
    isGroup: false,
    newMessages: 0,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "TEXT", //  TEXT, PHOTO, FILE
  },
  {
    id: "3",
    name: "უჯგუფესი ჯგუფი",
    status: true,
    isGroup: true,
    newMessages: 1,
    lastMessage: "გუშინ წინ რომ მითხარი გაწვიმდებაო, რატო არ გაწვიმდა?!",
    lastMessagedateTime: 3243243232,
    lastMessageType: "PHOTO", //  TEXT, PHOTO, FILE
  },
];

export const Conversation = {
  participantInfo: {
    id: 0,
    avatar: "/media/avatar/1.png",
    username: "მარიამ მარიამიძე",
    IsOnline: false,
  },
  messageList: [
    {
      id: 0,
      messageOwner: true,
      avatar: "/media/avatar/1.png",
      messageText: "საბეჭდი და ტიპოგრაფიული ინდუსტრიის უშინაარსო ტექსტია.",
      messageSendDate: "20:23 07.12.2020",
      messageSeenDate: "20:25 07.12.2020",
    },
    {
      id: 1,
      messageOwner: false,
      avatar: "/media/avatar/2.png",
      messageText:
        "Lorem Ipsum საბეჭდი და ტიპოგრაფიული ინდუსტრიის უშინაარსო ტექსტია. იგი სტანდარტად 1500-იანი წლებიდან იქცა, როდესაც უცნობმა მბეჭდავმა ამწყობ დაზგაზე წიგნის საცდელი ეგზემპლარი დაბეჭდა. მისი ტექსტი არამარტო 5 საუკუნის მანძილზე შემორჩა, არამედ მან დღემდე, ელექტრონული ტიპოგრაფიის დრომდეც უცვლელად მოაღწია. განსაკუთრებული პოპულარობა მას 1960-იან წლებში გამოსულმა Letraset-ის ცნობილმა ტრაფარეტებმა მოუტანა, უფრო მოგვიანებით კი — Aldus PageMaker-ის ტიპის საგამომცემლო პროგრამებმა, რომლებშიც Lorem Ipsum-ის სხვადასხვა ვერსიები იყო ჩაშენებული.    ",
      messageSendDate: "20:23 07.12.2020",
      messageSeenDate: "20:25 07.12.2020",
    },
    {
      id: 2,
      messageOwner: true,
      avatar: "/media/avatar/1.png",
      messageText: "საბეჭდი და ტიპოგრაფიული ინდუსტრიის უშინაარსო ტექსტია.",
      messageSendDate: "20:23 07.12.2020",
      messageSeenDate: "20:25 07.12.2020",
    },
    {
      id: 3,
      messageOwner: false,
      avatar: "/media/avatar/1.png",
      messageText: "საბეჭდი და ტიპოგრაფიული ინდუსტრიის უშინაარსო ტექსტია.",
      messageSendDate: "20:23 07.12.2020",
      messageSeenDate: "20:25 07.12.2020",
    },
  ],
};

export const participantDetail = {
  ParticipantInfo: {
    id: 0,
    avatar: "/media/avatar/1.png",
    username: "მარიამ მარიამიძე",
    city: "თბილისი",
    phone: "555 88 55 44",
    email: "name@gmail.com",
    address: "ბარათაშვილის 6ა",
  },
  media: [
    {
      id: 0,
      img: "/media/shared-photos/01.jpg",
    },
    {
      id: 1,
      img: "/media/shared-photos/02.jpg",
    },
    {
      id: 3,
      img: "/media/shared-photos/03.jpg",
    },
  ],
  files: [
    {
      id: 0,
      name: "ფაილის სახელი",
      size: "75 KB",
      type: "doc",
    },
    {
      id: 1,
      name: "ფაილის სახელი",
      size: "50 KB",
      type: "xlxs",
    },
    {
      id: 1,
      name: "ფაილის სახელი",
      size: "50 KB",
      type: "pdf",
    },
  ],
};


export const newChatSearchData = [
  {
    id: 0,
    fullname: "ანამარია სუხიტაშვილი",
    avatar: "./media/avatar/6.png",
    status: false,
    position: "მასწავლებელი",
    connectedPeople: [],
    connectedSubject: ['ბუნება', 'ქიმია', 'მათემატიკა']
  },
  {
    id: 1,
    fullname: "გიორგი სუხიტაშვილი",
    avatar: "./media/avatar/6.png",
    status: false,
    position: "მშობელი",
    connectedPeople: ['მარიამ სამსონაძე', "გიორგი სამსონაძე"],
    connectedSubject: []
  },
  {
    id: 2,
    fullname: "ანამარია სუხიტაშვილი",
    avatar: "./media/avatar/6.png",
    status: false,
    position: "მასწავლებელი",
    connectedPeople: [],
    connectedSubject: ['ბუნება', 'ქიმია', 'მათემატიკა']
  },
  {
    id: 3,
    fullname: "ანამარია სუხიტაშვილი",
    avatar: "./media/avatar/6.png",
    status: false,
    position: "მასწავლებელი",
    connectedPeople: [],
    connectedSubject: ['ბუნება', 'ქიმია', 'მათემატიკა']
  },
  {
    id: 4,
    fullname: "ანამარია სუხიტაშვილი",
    avatar: "./media/avatar/6.png",
    status: false,
    position: "მშობელი",
    connectedPeople: ['მარიამ სამსონაძე', "გიორგი სამსონაძე"],
    connectedSubject: []
  },
  {
    id: 0,
    fullname: "ანამარია სუხიტაშვილი",
    avatar: "./media/avatar/6.png",
    status: false,
    position: "მასწავლებელი",
    connectedPeople: [],
    connectedSubject: ['ბუნება', 'ქიმია', 'მათემატიკა']
  },
  {
    id: 1,
    fullname: "გიორგი სუხიტაშვილი",
    avatar: "./media/avatar/6.png",
    status: false,
    position: "მშობელი",
    connectedPeople: ['მარიამ სამსონაძე', "გიორგი სამსონაძე"],
    connectedSubject: []
  },
  {
    id: 2,
    fullname: "ანამარია სუხიტაშვილი",
    avatar: "./media/avatar/6.png",
    status: false,
    position: "მასწავლებელი",
    connectedPeople: [],
    connectedSubject: ['ბუნება', 'ქიმია', 'მათემატიკა']
  },
  {
    id: 3,
    fullname: "ანამარია სუხიტაშვილი",
    avatar: "./media/avatar/6.png",
    status: false,
    position: "მასწავლებელი",
    connectedPeople: [],
    connectedSubject: ['ბუნება', 'ქიმია', 'მათემატიკა']
  },
  {
    id: 4,
    fullname: "ანამარია სუხიტაშვილი",
    avatar: "./media/avatar/6.png",
    status: false,
    position: "მშობელი",
    connectedPeople: ['მარიამ სამსონაძე', "გიორგი სამსონაძე"],
    connectedSubject: []
  }
]